import React, { useEffect, useRef } from 'react';
import { isStringifiedArrayWithPropName,parseAndSortValues } from '../../../../helpers/ExportHelper'; 

export function CustomCellEditor(params) {
  const { value, onValueChange, api, eGridCell, eventKey, rowIndex, column,setIsEditing } = params;
  const refTextArea = useRef(null);
  const KEY_BACKSPACE = 'Backspace';
  
 const updateValue = (val) => {
    let formattedValue = val;
    if (formattedValue && isStringifiedArrayWithPropName(formattedValue)) {
      formattedValue = parseAndSortValues(formattedValue);
    }
    onValueChange(formattedValue === '' ? null : formattedValue);
  };

  useEffect(() => {
    let startValue;
    if (eventKey === KEY_BACKSPACE) {
      startValue = '';
    } else if (eventKey && eventKey.length === 1) {
      startValue =value === undefined ||value === null ? eventKey: value + eventKey;
    } else {
      startValue = value;
    }
    if (startValue == null) {
      startValue = '';
    }
    updateValue(startValue);

    if (refTextArea.current) {
      refTextArea.current.focus();
      const length = refTextArea.current.value.length;
      refTextArea.current.setSelectionRange(length, length);
    }
  }, []);

  const handleInput = () => {
    if (refTextArea.current) {
      refTextArea.current.style.height = 'auto';
      refTextArea.current.style.height = Math.min(refTextArea.current.scrollHeight + 4, 350) + 'px';
    }
  };

  const getColumnWidth = () => {
    const column = api.getColumn(params.column.colId);
    return column.actualWidth;
  };

  const handleEndKey = (e) => {
    if (e.keyCode === 36) {
      e.preventDefault();
      const length = 0;
      refTextArea?.current?.setSelectionRange(length, length);
    } else if (e.keyCode === 35) {
      e.preventDefault();
      const length = refTextArea.current.value.length;
      refTextArea?.current?.setSelectionRange(length, length);
    } else if (e.altKey && e.keyCode === 13) {
      handleInput();
      e.stopPropagation();
      e.preventDefault();
      const cursorPosition = refTextArea.current.selectionStart;
      const textBeforeCursor = refTextArea.current.value.substring(0, cursorPosition);
      const textAfterCursor = refTextArea.current.value.substring(cursorPosition);
      const newValue = `${textBeforeCursor}\n${textAfterCursor}`;

      // Set the new value with line break in textarea
      refTextArea.current.value = newValue;
      refTextArea.current.setSelectionRange(
        cursorPosition + 1,
        cursorPosition + 1
      );
      updateValue(newValue);
    }
  };

  return (
    <textarea
      rows={1}
      value={value || ''}
      ref={refTextArea}
      onKeyDownCapture={(e) => { handleEndKey(e); }}
      onChange={(event) => {
        const newValue = event.target.value;
        updateValue(newValue);
        handleInput();
      }}
      onFocus={(event) => {
          // Select entire text on focus
          // setTimeout(() => {
          //   event.target.select();
          // }, 0);
      }}
      style={{
        minWidth: getColumnWidth() + 'px',
        overflow: 'auto',
        resize: 'none',
        padding: '0.25rem 0.25rem 0.5rem',
        fontSize: eGridCell.style.fontSize || '12px',
        fontFamily: 'Arial',
        lineHeight: '1.2',
        outline: 'none',
        border: '2px solid #134157',
        borderRadius: '0.25rem',
        minHeight: Math.min(eGridCell.clientHeight + 20, 350) + 'px',
        maxHeight: '400px'
      }}
    />
  );
}
